module.exports = __webpack_public_path__ + "prod/1.42.2/img/zmhz-bg.641d27bd.png";